module.exports = __webpack_public_path__ + "static/media/50-points.c7fdb737.png";